import Cookies from 'js-cookie';
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { getLob, setDashboardCookies } from '../../services/authenticationService';
import { Loader } from '../../components/loader/Loader';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import store from '../../stateManagement/store';
import { getAuthServiceState, getSalesCodeAuthClient } from '../../services/salescodeAuthService';


function ScaiAgentDashboard() {

  const [loading , setLoading] = useState(true);

  const lob = getLob();
  const env =  EnvironmentRegistry.getEnvironment();
  const endToEndEnabled = localStorage.getItem("endToend") === "true";


  if(!env){
    throw new Error("Environment not set");
  }

  const iframeUrl  = EnvironmentRegistry.getSalesAgentUrl(env);
  const iframeUrlRef = useRef<string>(`${iframeUrl}/auth/login?lob=${lob}&env=${env}&endToend=${endToEndEnabled}&source=salescodestudio`);
 
  const init = useCallback(async()=>{
    try{
      setLoading(true);
      const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
      let secureToken = (await networkService.authState.getHttpEncryptionKey()) || sessionStorage.getItem("secureToken");
      const client = await getSalesCodeAuthClient();      
      const encryptedSecureToken = await client.getEncryptedSecureToken(secureToken);
      const {isAuthService} = await getAuthServiceState();
      if (secureToken === null || secureToken === undefined) {
        secureToken = null;
      }
      iframeUrlRef.current += `&authSdk=${isAuthService}`;
      Cookies.set("secureToken",secureToken,{domain:'.salescode.ai',path:'/',samesite:'strict'});
      Cookies.set("encryptedSecureToken",encryptedSecureToken,{domain:'.salescode.ai',path:'/',samesite:'strict'});
      await setDashboardCookies();
      
    }catch(err){
      console.error(err);
    }finally{
      setLoading(false);
    }
  },[]);

  useEffect(()=>{
    init();
  },[]);

  return (
    <div style={{ width: '100%', height: '100%', borderRadius: '5px', overflow: 'hidden' }}>
      {
        loading ?
          <Loader />
          : <iframe
            title='scaiAgentDashboard'
            style={{ "border": "0px", overflow: 'hidden' }}
            width={"100%"}
            height={"100%"}
            loading={"lazy"}
            src={iframeUrlRef.current}
          />
      }
    </div>
  )
}

export default ScaiAgentDashboard
